import React from 'react';

import UsersIcon from 'assets/Icons/sidebarIcons/UsersIcon';
import CardsIcon from 'assets/Icons/sidebarIcons/CardsIcon';
import ResourcesIcon from 'assets/Icons/sidebarIcons/ResourcesIcon';
import BookingsIcon from 'assets/Icons/sidebarIcons/BookingsIcon';
import OrganizationIcon from 'assets/Icons/sidebarIcons/OrganizationIcon';
import FunctionsIcon from 'assets/Icons/sidebarIcons/FunctionsIcon';
import SpacesIcon from 'assets/Icons/sidebarIcons/SpacesIcon';
import BusinessIcon from '@mui/icons-material/Business';
import PersonIcon from '@mui/icons-material/Person';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import AIAssistantIcon from 'assets/Icons/sidebarIcons/AIAssistantIcon';

export const navItemsList = (role: string | null) => {
  switch (role) {
    case 'SUPER':
      return [
        { to: '/accounts', icon: <AccountBoxIcon />, label: 'Accounts' },
        { to: '/buildings', icon: <BusinessIcon />, label: 'Buildings' },
        { to: '/organizations', icon: <OrganizationIcon />, label: 'Organizations' },
        {
          to: '/',
          icon: <UsersIcon />,
          label: 'Users',
          subItems: [
            { to: '/admins', label: 'Admins' },
            { to: '/occupants', label: 'Occupants' },
            { to: '/visitors', label: 'Visitors' }
          ]
        },
        { to: '/cards', icon: <CardsIcon />, label: 'Cards' },
        {
          to: '/',
          icon: <SpacesIcon />,
          label: 'Spaces',
          subItems: [
            { to: '/spaces/live', label: 'Live' },
            { to: '/spaces/reporting', label: 'Reporting' },
            { to: '/spaces/manage', label: 'Manage' }
          ]
        },
        { to: '/resources', icon: <ResourcesIcon />, label: 'Amenities' },
        {
          to: '/',
          icon: <BookingsIcon />,
          label: 'Bookings',
          subItems: [
            { to: '/bookings/live', label: 'Live' },
            { to: '/bookings/reporting', label: 'Reporting' },
            { to: '/bookings/manage', label: 'Manage' }
          ]
        },
        { to: '/ai-assistant', icon: <AIAssistantIcon />, label: 'AI Assistant' },

        // Settings dropdown menu with all SUPER user specific tabs only
        {
          to: '/',
          icon: <FunctionsIcon />,
          label: 'Settings',
          subItems: [
            { to: '/trainer', label: 'Trainer' },
            { to: '/functions', label: 'Functions' },
            { to: '/types', label: 'Types' },
            { to: '/Units', label: 'Units' },
            { to: '/sensors', label: 'Sensors' },
            { to: '/surveys', label: 'Surveys' },
            { to: '/integrations', label: 'Integrations' },
            {
              to: '/integration-preferences',
              label: 'Preferences'
            },
            { to: '/integration-keys', label: 'Keys' }
          ]
        },

        // My Profile Manage & Logout Section
        {
          to: '/',
          icon: <PersonIcon />,
          label: 'My Profile',
          subItems: [
            { to: '/profile', label: 'Manage' },
            { label: 'Log Out', action: 'logout' }
          ]
        }
      ];
    case 'ACCOUNT':
      return [
        { to: '/accounts', icon: <AccountBoxIcon />, label: 'Account' },
        { to: '/buildings', icon: <BusinessIcon />, label: 'Buildings' },
        { to: '/organizations', icon: <OrganizationIcon />, label: 'Organizations' },
        {
          to: '/',
          icon: <UsersIcon />,
          label: 'Users',
          subItems: [
            { to: '/admins', label: 'Admins' },
            { to: '/occupants', label: 'Occupants' },
            { to: '/visitors', label: 'Visitors' }
          ]
        },
        { to: '/cards', icon: <CardsIcon />, label: 'Cards' },
        {
          to: '/',
          icon: <SpacesIcon />,
          label: 'Spaces',
          subItems: [
            { to: '/spaces/live', label: 'Live' },
            { to: '/spaces/reporting', label: 'Reporting' },
            { to: '/spaces/manage', label: 'Manage' }
          ]
        },
        { to: '/resources', icon: <ResourcesIcon />, label: 'Amenities' },
        {
          to: '/',
          icon: <BookingsIcon />,
          label: 'Bookings',
          subItems: [
            { to: '/bookings/live', label: 'Live' },
            { to: '/bookings/reporting', label: 'Reporting' },
            { to: '/bookings/manage', label: 'Manage' }
          ]
        },
        { to: '/ai-assistant', icon: <AIAssistantIcon />, label: 'AI Assistant' },

        // My Profile Manage & Logout Section
        {
          to: '/',
          icon: <PersonIcon />,
          label: 'My Profile',
          subItems: [
            { to: '/profile', label: 'Manage' },
            { label: 'Log Out', action: 'logout' }
          ]
        }
      ];
    case 'BUILDING':
      return [
        { to: '/buildings', icon: <BusinessIcon />, label: 'Building' },
        { to: '/organizations', icon: <OrganizationIcon />, label: 'Organizations' },
        {
          to: '/',
          icon: <UsersIcon />,
          label: 'Users',
          subItems: [
            { to: '/occupants', label: 'Occupants' },
            { to: '/visitors', label: 'Visitors' }
          ]
        },
        { to: '/cards', icon: <CardsIcon />, label: 'Cards' },
        {
          to: '/',
          icon: <SpacesIcon />,
          label: 'Spaces',
          subItems: [
            { to: '/spaces/live', label: 'Live' },
            { to: '/spaces/reporting', label: 'Reporting' },
            { to: '/spaces/manage', label: 'Manage' }
          ]
        },
        { to: '/resources', icon: <ResourcesIcon />, label: 'Amenities' },
        {
          to: '/',
          icon: <BookingsIcon />,
          label: 'Bookings',
          subItems: [
            { to: '/bookings/live', label: 'Live' },
            { to: '/bookings/reporting', label: 'Reporting' },
            { to: '/bookings/manage', label: 'Manage' }
          ]
        },
        { to: '/ai-assistant', icon: <AIAssistantIcon />, label: 'AI Assistant' },

        // My Profile Manage & Logout Section
        {
          to: '/',
          icon: <PersonIcon />,
          label: 'My Profile',
          subItems: [
            { to: '/profile', label: 'Manage' },
            { label: 'Log Out', action: 'logout' }
          ]
        }
      ];
    case 'ORG':
      return [
        { to: '/organizations', icon: <OrganizationIcon />, label: 'Organization' },
        { to: '/occupants', icon: <UsersIcon />, label: 'Occupants' },

        // My Profile Manage & Logout Section
        {
          to: '/',
          icon: <PersonIcon />,
          label: 'My Profile',
          subItems: [
            { to: '/profile', label: 'Manage' },
            { label: 'Log Out', action: 'logout' }
          ]
        }
      ];
  }
};
